import { records as userRecords } from '@saucelabs/sl-module-user';

import constants from './constants';

const isActiveFreeUser = (user: userRecords.UserRecord): boolean => (
  user?.isFreeTrial() || user?.isFreemiumCapable()
);

const sanitizeTestNameInput = (testName = ''): string => {
  // using spread operator to treat emoji as individual char
  const characters = [...testName].slice(0, constants.TEST_NAME_MAX_CHAR_LENGTH);
  return characters
    .filter((char) => new Blob([char]).size <= constants.TEST_NAME_CHAR_BYTE_MAX_LENGTH)
    .join('');
};

export default {
  isActiveFreeUser,
  sanitizeTestNameInput,
};
